import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Footer from "./Footer";
import LandingPage from "./LandingPage";
import Vechungtoi from "./Vechungtoi";
import Giohangcuaban from "./Giohangcuaban";
import BouquetDesignerPage from "./BouquetDesignerPage";
import Thanhtoan from "./Thanhtoan";
import TulipChatbot from "./TulipChatbot";
import Admin from "./Admin";
import Theodoidonhang from "./Theodoidonhang";
import Lienhe from "./Lienhe";
import MainLayout from "./MainLayout";
import Dangnhap from "./Dangnhap";
import Dangky from "./Dangky";
import HoaDungDip from "./HoaDungDip";
import HoaHopTui from "./HoaHopTui";
import FlowerDetail from "./FlowerDetail";
import Matnguloaihoa from "./Matnguloaihoa";
import Timkiem from "./Timkiem";
import Congdong from "./Congdong";
function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/tim-kiem" element={<Timkiem />} />
          <Route path="/thiet-ke-bo-hoa" element={<BouquetDesignerPage />} />
          <Route path="/ve-chung-toi" element={<Vechungtoi />} />
          <Route path="/gio-hang-cua-ban" element={<Giohangcuaban />} />
          <Route path="/thanh-toan" element={<Thanhtoan />} />
          <Route path="/theo-doi-don-hang" element={<Theodoidonhang />} />
          <Route path="/lien-he" element={<Lienhe />} />
          <Route path="/dang-nhap" element={<Dangnhap />} />
          <Route path="/dang-ky" element={<Dangky />} />
          <Route path="/dung-dip" element={<HoaDungDip />} />
          <Route path="/dung-dip/:dip" element={<HoaDungDip />} />
          <Route path="/hop-tui" element={<HoaHopTui />} />
          <Route path="/hop-tui/:muc" element={<HoaHopTui />} />
          <Route path="/hoa/:id" element={<FlowerDetail />} />
          <Route path="/mat-ngu-loai-hoa" element={<Matnguloaihoa />} />
          <Route path="/mat-ngu-loai-hoa/:type" element={<Matnguloaihoa />} />
          <Route path="/mat-ngu-loai-hoa/:type/:flowerSlug" element={<Matnguloaihoa />} />
          <Route path="/cong-dong" element={<Congdong />} />
          {/* Catch-all route for flower slugs - display LandingPage with popup */}
          <Route path="/:slug" element={<LandingPage />} />
        </Route>
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdminPage && <TulipChatbot />}
      {!isAdminPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;